import React from "react";
import { Box, Button, MenuItem, Select, Stack, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchArea from "@/comp/SearchArea";
import SearchLabel from "@/comp/SearchLabel";
import commonTextFieldProps from "@/comp/CommonTextFieldProps";

const selectStyle = { width: 130, height: 26, backgroundColor: "#fff", fontSize: 12 };
const menuProps = { sx: { zIndex: (theme) => theme.zIndex.modal + 3 } };

const SearchOrderHistorySearchBar = ({ conditions, departmentOptions, onChange, onReset, onSearch }) => (
  <SearchArea showSearchButton={false} sx2={{ flexWrap: "wrap", width: "100%" }}>
    <Stack direction="row" alignItems="center" spacing={1}>
      <SearchLabel label="주문일자" />
      <TextField {...commonTextFieldProps} type="date" value={conditions.orderDate} onChange={onChange("orderDate")} sx={{ width: 150 }} />
    </Stack>
    <Stack direction="row" alignItems="center" spacing={1}>
      <SearchLabel label="소속" />
      <Select value={conditions.department} onChange={onChange("department")} MenuProps={menuProps} displayEmpty size="small" sx={selectStyle}>
        <MenuItem value="">전체</MenuItem>
        {departmentOptions.map((department) => (
          <MenuItem key={department.value} value={department.value}>{department.label}</MenuItem>
        ))}
      </Select>
    </Stack>
    <Stack direction="row" alignItems="center" spacing={1}>
      <SearchLabel label="수정자명" />
      <TextField {...commonTextFieldProps} value={conditions.modifier} onChange={onChange("modifier")} sx={{ width: 130 }} />
    </Stack>
    <Stack direction="row" alignItems="center" spacing={1}>
      <SearchLabel label="주문번호" />
      <TextField {...commonTextFieldProps} value={conditions.orderNo} onChange={onChange("orderNo")} sx={{ width: 130 }} />
    </Stack>
    <Box sx={{ marginLeft: "auto", display: "flex", gap: 1 }}>
      <Button variant="outlined" size="small" onClick={onReset} sx={{ height: 26, fontSize: 12 }}>초기화</Button>
      <Button variant="contained" size="small" startIcon={<SearchIcon />} onClick={onSearch} sx={{ height: 26, fontSize: 12 }}>조회</Button>
    </Box>
  </SearchArea>
);

export default SearchOrderHistorySearchBar;
